var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"focus-style collapse-icon mouse-hover",class:{ 'collapse-icon--expanded': _vm.value }},[_c('span',{staticClass:"fa",class:'fa-chevron-right font-size'})])
}
var staticRenderFns = []

export { render, staticRenderFns }